import { FC } from 'react';
import cs from 'classnames';
import { useAtomValue } from 'jotai';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { $HitArticleGptSupplements } from '~/utils/libra/article-gpt-tdk';
import { $CurrentArticleGPTInfo } from '../../atoms/current-article-gpt-info';

import './style.scss';

interface IGptSupplementsProps {
  inVideo?: boolean;
}

export const GptSupplements: FC<IGptSupplementsProps> = ({ inVideo }) => {
  const HitArticleGptSupplements = useAtomValue($HitArticleGptSupplements);
  const { supplements } = useAtomValue($CurrentArticleGPTInfo);
  const { isBot } = useAtomValue($UserAgent);

  if (!HitArticleGptSupplements || !supplements || !isBot) {
    return null;
  }

  return (
    <div
      className={cs('gpt-supplements-module', {
        'white-font': inVideo,
      })}
    >
      {supplements}
    </div>
  );
};
